import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import SearchFilterTable from '../../microComponents/tablePages/filter/SearchFilterTable';
import UseSetParams from '../../microComponents/tablePages/filter/UseSetParams';
import SelectFilterTable from '../../microComponents/tablePages/filter/SelectFilterTable';
import {Popconfirm, Switch} from "antd";
import GetProductList from "../Products/GetProductList";
import {getFilterDetailsList} from "../../microComponents/tablePages/getFilterDetailsList";
import {getFilterProductLine} from "../../microComponents/tablePages/getFilterProductLine";
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
import {getFilterPalletStatus} from "../../microComponents/tablePages/getFilterPalletStatus";
import {getFilterLocation} from "../../microComponents/tablePages/getFilterLocation";
import {getFilterQcStatus} from "../../microComponents/tablePages/getFilterQcStatus";
import SearchFilterTableNumber from "../../microComponents/tablePages/filter/SearchFilterTableNumber";
import PalletStatus from "../../microComponents/elements/PalletStatus";
import DateFilterTable from "../../microComponents/tablePages/filter/DateFilterTable";
import {allowLoadJson} from "../../helper/jsons/activatedJson";
import DropDownPallet from "./DropDownPallet";
import {toast} from "react-toastify";
import Pallet from "../../http_request/Model/pallet/Pallet";
import {getAgainHandler} from "../../store/TableRedux/TableRedux";
import HandleSubmitButton from "./HandleSubmitButton";


const PalletStatusColumn = () => {
    const dispatch = useDispatch();
    const [getColumnSelectProps] = SelectFilterTable();
    const [getColumnDateProps,] = DateFilterTable()
    const [handleSetParams] = UseSetParams();

    const filter = useSelector((state) => state.TableRedux.filter);
    const qc = useSelector((state) => state.SettingRedux.qc);
    const entry = useSelector((state) => state.SettingRedux.entry);
    const order = useSelector((state) => state.SettingRedux.order);
    const [getColumnSearchProps] = SearchFilterTable();
    const [getColumnSearchPropsNumber] = SearchFilterTableNumber();
    const [productList, setProductList] = useState([]);
    const [productListLoading, setProductListLoading] = useState(false);


    const [filterDetailsList, setFilterDetailsList] = useState({});
    const [filterDetailsListLoading, setFilterDetailsListLoading] = useState(false);
    const [filterProductLine, setFilterProductLine] = useState([]);
    const [productLineLoading, setProductLineLoading] = useState(false);
    const [filterBranch, setFilterBranch] = useState([]);
    const [branchLoading, setBranchLoading] = useState(false);
    const [filterPalletStatus, setFilterPalletStatus] = useState([]);
    const [palletStatusLoading, setPalletStatusLoading] = useState(false);
    const [filterLocation, setFilterLocation] = useState([]);
    const [locationLoading, setLocationLoading] = useState(false);
    const [qcStatusList, setQcStatusList] = useState([]);
    const [qcStatusLoading, setQcStatusLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingSwitch, setLoadingSwitch] = useState(false);
    const [selectedPalletId, setSelectedPalletId] = useState();


    const funcHandleSetParams = (newFilter) => {
        handleSetParams(newFilter);
    };

    const ReqQc = (rowData) => {
        let data = {...qc}
        data.palletId = rowData.palletId
        setSelectedPalletId(rowData.palletId)
        Pallet.request({
            beforeSend: () => {
                setLoading(true)
            }, success: () => {
                toast.success('تغییرات با موفقیت اعمال شد.');
                dispatch(getAgainHandler())
            }, error: (error) => {
                toast.error(error?.data?.message);

            }, final: () => {
                setLoading(false)
            },


        }).palletQc(data);
    }
    const ReqEntry = (rowData) => {
        setSelectedPalletId(rowData.palletId)
        let data = {...entry}
        data.palletId = rowData.palletId


        Pallet.request({
            beforeSend: () => {
                setLoading(true)
            }, success: () => {
                toast.success('تغییرات با موفقیت اعمال شد.');
                dispatch(getAgainHandler())
            }, error: (error) => {
                toast.error(error?.data?.message);
            }, final: () => {
                setLoading(false)

            },


        }).palletWarehouseEntry(data);
    }
    const ReqOrder = (rowData,) => {


        setSelectedPalletId(rowData.palletId)
        Pallet.request({
            beforeSend: () => {
                setLoading(true)

            }, success: () => {
                toast.success('تغییرات با موفقیت اعمال شد.');
                dispatch(getAgainHandler())
            }, error: (error) => {
                toast.error(error?.data?.message);

            }, final: () => {
                setLoading(false)

            },


        }).addParams({pid: rowData.palletId}).palletOrder(order.orderNumber)
    }


    useEffect(() => {
        getFilterDetailsList(setFilterDetailsList, setFilterDetailsListLoading)
    }, [])


    const handleGetFilterProductLine = () => {

        getFilterProductLine(setFilterProductLine, setProductLineLoading)
    }


    const handleAllowLoad = (id, status) => {
        const data = {
            "palletId": id,
            "allowLoad": !status,
        }
        setSelectedPalletId(id)
        Pallet.request({
            beforeSend: () => {
                setLoadingSwitch(true)

            }, success: () => {
                toast.success('تغییرات با موفقیت اعمال شد.');
                dispatch(getAgainHandler())
            }, error: (error) => {
                toast.error(error.data.message);

            }, final: () => {
                setLoadingSwitch(false)

            },


        }).updateWarehouse(data);


    }

    const handleGetFilterLocation = () => {

        getFilterLocation(setFilterLocation, setLocationLoading)
    }

    const handleGetFilterBranch = () => {

        getFilterBranch(setFilterBranch, setBranchLoading)
    }
    const handleGetFilterPalletStatus = () => {

        getFilterPalletStatus(setFilterPalletStatus, setPalletStatusLoading)
    }

    const handleGetFilterQcStatus = () => {

        getFilterQcStatus(setQcStatusList, setQcStatusLoading)
    }

    const getProductList = () => {
        GetProductList(setProductList, setProductListLoading)
    }


    const columns = [
        {
            title: ' شناسه اموال',

            dataIndex: 'palletId',
            key: 'palletId', ...getColumnSearchPropsNumber('شناسه اموال', filter.palletId, (res) => {
                funcHandleSetParams([{key: 'palletId', value: res}]);
            }, 16, 'palletId'),
        }, {
            title: 'کالا', className: "hidden 2xs:table-cell",
            dataIndex: 'product',
            key: 'product', ...getColumnSelectProps(filter.product, 'product', 'کالا', productList, getProductList, (res) => {

                funcHandleSetParams([{key: 'product', value: res}]);
            }, productListLoading),
        },
        {

            title: ' برند', className: "hidden sm:table-cell",
            dataIndex: 'brand',
            key: 'brand', ...getColumnSelectProps(filter.brand, 'brand', 'برند', filterDetailsList?.brand, null, (res) => {
                funcHandleSetParams([{key: 'brand', value: res}]);
            }, filterDetailsListLoading),
        }, 

		{
            title: 'وضعیت شناسه', className: "hidden md:table-cell",
            dataIndex: 'palletStatus',
            key: 'palletStatus',
            ...getColumnSelectProps(filter.brand, 'PalletStatus', 'وضعیت شناسه', filterPalletStatus, handleGetFilterPalletStatus, (res) => {
                funcHandleSetParams([{key: 'PalletStatus', value: res}]);
            }, palletStatusLoading),
            render: (item, row) => {
                return <PalletStatus data={row}/>
            }

        }, {
            title: 'واحد', className: "hidden 2md:table-cell",
            dataIndex: 'branch',
            key: 'branch', ...getColumnSelectProps(filter.branch, 'branch', 'واحد', filterBranch, handleGetFilterBranch, (res) => {
                funcHandleSetParams([{key: 'branch', value: res}]);
            }, branchLoading),
        },


        {
            title: 'موقعیت', className: "hidden lg:table-cell",
            dataIndex: 'location',
            key: 'location', ...getColumnSelectProps(filter.locations, 'locations', 'موقعیت', filterLocation, handleGetFilterLocation, (res) => {
                funcHandleSetParams([{key: 'locations', value: res}]);
            }, locationLoading),
        }, 

		{
            title: 'قیمت', className: "hidden lg:table-cell",
            dataIndex: 'consumerPriceRials',
            key: 'consumerPriceRials', ...getColumnSearchProps('قیمت', filter.consumerPriceRials, (res) => {
                funcHandleSetParams([{key: 'consumerPriceRials', value: res}]);
            }, 'consumerPriceRials'),
        },


		{
            title: ' وضعیت کالا', className: "hidden lg:table-cell",
            dataIndex: 'qcStatus',
            key: 'qcStatus',

            ...getColumnSelectProps(filter.qcStatus, 'qcStatus', 'وضعیت کالا', qcStatusList, handleGetFilterQcStatus, (res) => {
                funcHandleSetParams([{key: 'qcStatus', value: res}]);
            }, qcStatusLoading),

        }, 
		
		{
            title: 'تعداد کالا', className: "hidden lg:table-cell",
            dataIndex: 'numberPerPallet',
            key: 'numberPerPallet'
        },

        {
            title: 'شماره حواله', className: "hidden lg:table-cell",
            // className: 'hidden xl:block',
            dataIndex: 'orderCode',
            key: 'orderCode', ...getColumnSearchProps('شماره حواله', filter.orderCode, (res) => {
                funcHandleSetParams([{key: 'orderCode', value: res}]);
            }, 'orderCode'),
        },

        {
            fixed: 'right', className: `${(qc || entry || order) ? 'left-120' : 'left-73'} cell-fix-left`,
            title: 'جابجایی',
            dataIndex: 'allowLoadId',
            key: 'allowLoadId', ...getColumnSelectProps(filter.allowLoad, 'allowLoad', 'وضعیت جابجایی', allowLoadJson, null, (res) => {
                funcHandleSetParams([{key: 'allowLoad', value: res}]);
            }, false, 'single'), render: (item, row) => {
                return <div>
                    <Switch loading={selectedPalletId === row.palletId && loadingSwitch} onClick={() => {
                        handleAllowLoad(row.palletId, item)
                    }} checked={item} unCheckedChildren='نشود'
                            className='bg-amber-600'
                            checkedChildren='شود'/>
                </div>

            }
        },
        {

            fixed: 'right',
            title: 'عملیات',
            // className: 'hidden xl:block',
            dataIndex: 'events',
            key: 'events',
            render: (x, row) => {
                return <div className='flex gap-1' >

                    {
                        (qc || entry || order) ?
                            <Popconfirm
                                title={`${!row.allowLoadId ? 'وضعیت بارگیری نشود است.' : ''}${row.qcStatus !== 'تایید' ? `وضعیت کنترل کیفی ${row.qcStatus} است.` : ''}`}
                                disabled={qc || (row.allowLoadId && row.qcStatus === 'تایید')}
                                onConfirm={() => {
                                    qc ? ReqQc(row) : entry ? ReqEntry(row) : ReqOrder(row)

                                }}>


                                <div>
                                    <HandleSubmitButton
                                        loading={selectedPalletId === row.palletId && loading} onClick={() => {


                                        if (qc || (row.allowLoadId && row.qcStatus === 'تایید')) {
                                            qc ? ReqQc(row) : entry ? ReqEntry(row) : ReqOrder(row)

                                        }
                                    }}/>
                                </div>


                            </Popconfirm>


                            :

                            <DropDownPallet data={row}/>


                    }

                </div>


            }
        },


    ];
    return [columns];
};

export default PalletStatusColumn;